import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocale } from "../../contexts/localeContext";
import { Lookup } from "../../models/Lookup";
import { ListQuery } from "../../models/ListQuery";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import TableTab from "../../components/tabs/table-tab";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { ListData } from "../../models/ListData";
import { DEF_PG_SIZE_SUB } from "../../constants/maximum-page-size";
import EnrolmentAuditColumns from "../../models/ColumnDefinitions/EnrolmentAuditColumns";
import EnrolmentAuditSearch from "../../models/search/EnrolmentAuditSearch";
import { getAuditForPerson } from "../../services/auditService";
import { appendFilter } from '../../utilities/filters';
import { getDateForPreviousThirtyDays, getTodayDate } from "../../utilities/DateUtils";
import { REPORTS_AUDIT } from "../../constants/menu-types";
import { showError } from "../../services/utilities/ServiceError";
import { toast } from "react-toastify";


interface Props {
    masterId?: number;
}

const UserAuditTab: FC<Props> = ({ masterId = 0}) => {
    const { translate } = useLocale();
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const userLoginId = useSelector((state: any) => (state.userInfo.id))

    const getTableData = (listParameters?) => {
        if (listParameters.filters) {
            listParameters.filters = listParameters.filters.filter((filter) => filter.key !== "dateOnly"); // removing date filters because service doesn't require them
        }

        return getAuditForPerson(masterId.toString(), { 
            ...listParameters, 
            filters: appendFilter(masterId, 'Master', 'masterId', listParameters?.filters) },
            translate)
    }

    // default to a method that returns nothing
    // when putting a method in a state variable, useState requires us to return the method from a method, hence the wrapped inner method.
    const [dataRefresh, setDataRefresh] = useState(() => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => { return });
    
    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => {
        setDataRefresh(() => refreshData);
    }
    // <-- end context

    // method that is builds uneditable filter that contains two dates (todays date and previous 30 days)
    const buildDateFilter = (setDetails) => {
        try {
            const previousThirtyDaysDate = getDateForPreviousThirtyDays();
            const todaysDate = getTodayDate();
            const date = `${previousThirtyDaysDate};${todaysDate}`;

            const customFilter = [{
                key: "dateOnly",
                label: "Date",
                options: [
                    { label: date, value: date },
                ],
                selected: [
                    { label: date, value: date },
                ],
            }];

            setDetails(userLoginId, REPORTS_AUDIT, customFilter);
        } catch (error) {
                showError(error, toast.warn);
        }
    };
    // <-- end context
    useEffect(() =>{
        dataRefresh(getTableData);
    },[masterId, translate])

    return (<TableContextProvider
        dataMethod={(listParameters) => getTableData(listParameters)}
        initialiser={(setDetails) => buildDateFilter(setDetails)}
        manualDataRefresh={manualDataRefresh}
        tableDescriptor={EnrolmentAuditColumns}
        searchDescriptor={EnrolmentAuditSearch}
        useFilter
        useSearch
        usePagination
        maxPageSize={DEF_PG_SIZE_SUB}
        useTable
        lookup={lookup}>
        <TableTab
            title={''}
            reportTitle={translate.byKey(TranslationKeys.audit)}
            selectRows={false}
            showFilterMenu={false}
            disableFilterToggling ={true}
            cyName="userAudit"
            >
        </TableTab>
    </TableContextProvider >
    );
};

export default UserAuditTab;